// Build-time values that mean "no real release version is known"
export const PLACEHOLDER_VERSIONS = ['latest', 'unknown'] as const;

const PLACEHOLDER_SET: ReadonlySet<string> = new Set(PLACEHOLDER_VERSIONS);

/**
 * Normalises a raw release version for display as `v<version>`.
 * Returns null when the value is empty or a placeholder, so callers can hide the label.
 */
export function formatReleaseVersion(raw: string | undefined | null): string | null {
  const trimmed = raw?.trim() ?? '';
  if (!trimmed || PLACEHOLDER_SET.has(trimmed.toLowerCase())) {
    return null;
  }

  const version = trimmed.replace(/^[vV]/, '');
  return version ? `v${version}` : null;
}
